const Egg = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'>
            <g transform='translate(0 0)'>
                <rect x='0.5' y='0.5' width='19' height='19' fill='#fff' stroke='#ff6d00' strokeWidth='1' />
                <path
                    d='M10 4.2c-2.4 0-4.4 2.9-4.4 6.2 0 3 2 5.1 4.4 5.1s4.4-2.1 4.4-5.1c0-3.3-2-6.2-4.4-6.2z'
                    fill='#ff6d00'
                />
            </g>
        </svg>
    )
}

export default Egg

